<template>
  <div class="zy-mask" :class="{ 'mask-show': show }" v-if="displayType"></div>
  <div class="zy-win-popup" :class="{ 'popup-show': show, 'zy-win-shake': shake }" v-if="displayType" :style="left !== -1 && top !== -1 ? `left:${left}px;top:${top}px`: ''">
    <div class="zy-top">
      <span class="zy-title">{{ title }}</span>
      <span class="zy-option">
        <div class="zy-btn-refresh" v-if="isHasRefresh && !imgLoading" @click="refresh">
          <i class="xl-icon icon iconfont" style="font-size: 16px; line-height: 16px;">
            <RefreshRight />
          </i>
        </div>
        <div class="zy-btn-close" @click="close(true)">
          <i class="xl-icon icon iconfont" style="font-size: 16px; line-height: 16px;">
            <Close2 />
          </i>
        </div>
      </span>
    </div>
    <div class="zy-line"></div>
    <slot />
  </div>
</template>
<script setup>
import { ref, computed } from 'vue';
import {
  RefreshRight,
  Close2
} from '@shining3d/icons-vue'
const props = defineProps({
  title: {
    type: String,
    default: '请完成安全验证'
  },
  useType: {
    type: String,
    default: 'ali'
  },
  left: {
    type: Number,
    default: 0
  },
  top: {
    type: Number,
    default: 0
  },
  sceneID: {
    type: String,
    default: ''
  },
  imgLoading: {
    type: Boolean,
    default: false
  },
  shake: {
    type: Boolean,
    default: false
  }
})
const sliderType = [
  '1x00dz3h',
  '1mu75wie'
]
const isHasRefresh = computed(() => {
  if(props.useType === 'slider'){
    return false;
  } else if(props.useType === 'ali' && sliderType.includes(props.sceneID)){
    return false;
  }
  return true
})
const emits = defineEmits(["close", "refresh"]);
const show = ref(false);
const displayType = ref(false);
const doShow = () => {
  displayType.value = true;
  show.value = true;
}
const close = (flag) => {
  show.value = false;
  setTimeout(() => {
    displayType.value = false;
    if(flag){
      emits('close');
    }
  }, 200)
}
const refresh = () => {
  emits('refresh');
}
defineExpose({doShow, close});
</script>
<style lang="scss" scoped>
.xl-icon svg {
  width: 1em;
  height: 1em;
}
.zy-mask {
  background: #000;
  height: 100%;
  left: 0;
  opacity: 0;
  position: fixed;
  top: 0;
  transition: all .4s ease-in-out;
  width: 100%;
  z-index: 10000000;
  &.mask-show {
    opacity: .5;
  }
}
.zy-win-popup{
  background-color: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  left: 50%;
  padding: 8px 16px;
  position: fixed;
  top: 45%;
  opacity: 0;
  transform: translate(-50%,-50%);
  transition: all .2s ease-in-out;
  visibility: visible;
  z-index: 10000001;
  min-width: 300px;
  &.popup-show{
    opacity: 1;
  }
  &.zy-win-shake{
    animation: aliyunCaptcha_shake .2s ease 4 both;
  }
}
.zy-top{
  align-items: center;
  display: flex;
  flex-direction: row;
  height: 32px;
  justify-content: space-between
}
.zy-title{
  font-size: 16px;
  line-height: 36px;
  font-family: "aliFontT65", "aliFontO65";
}
.zy-line {
  border: .5px solid #eff1f7;
  margin: 8px 0;
}
.zy-btn-close, .zy-btn-refresh {
  cursor: pointer;
  margin-left: 12px;
}
.zy-option {
  display: flex;
  align-items: center;
}
@keyframes aliyunCaptcha_shake {
  25% {
    margin-left: -6px;
  }

  75% {
    margin-left: 6px;
  }

  to {
    margin-left: 0;
  }
}
</style>
